import { AxiosError } from "axios";

import { ADMIN_API_ENDPOINTS } from "@/config/apiEndpoints/adminUrls";
import { handleApiError } from "@/lib/utils";
import { IDigitalLearning } from "@/types/page";
import adminAxios from "@/lib/axios";

export async function createDigitalLearning(
  payload: Partial<IDigitalLearning>
) {
  try {
    const response = await adminAxios.post(
      ADMIN_API_ENDPOINTS.DIGITAL_LEARNING.CREATE,
      payload
    );

    return response?.status === 201 ? response?.data : null;
  } catch (error) {
    const errorResponse = handleApiError(error as AxiosError);
    return errorResponse ? errorResponse : null;
  }
}

export async function updateDigitalLearning(
  id: number,
  payload: Partial<IDigitalLearning>
) {
  try {
    const response = await adminAxios.put(
      ADMIN_API_ENDPOINTS.DIGITAL_LEARNING.UPDATE(id),
      payload
    );

    return response?.status === 200 ? response?.data : null;
  } catch (error) {
    const errorResponse = handleApiError(error as AxiosError);
    return errorResponse ? errorResponse : null;
  }
}
